import { browserHistory, IndexRoute, Router, Route} from 'react-router'
import { Provider } from 'react-redux'
import Anonymous from 'client/features/app/containers/Anonymous.jsx'
import App from 'client/features/app/containers/App.jsx'
import Logged from 'client/features/app/containers/Logged.jsx'
import Home from 'client/features/home/containers/Home.jsx'
import Login from 'client/features/session/containers/Login.jsx'
import ResetPassword from 'client/features/session/containers/ResetPassword.jsx'
import NewPassword from 'client/features/session/containers/NewPassword.jsx'
import SetPassword from 'client/features/session/containers/SetPassword.jsx'
import Clients from 'client/features/client/containers/Clients.jsx'
import Client from 'client/features/client/containers/Client.jsx'
import Hives from 'client/features/hives/containers/Hives.jsx'
import Users from 'client/features/users/containers/Users.jsx'
import User from 'client/features/users/containers/User.jsx'
import initStore from './store.js'
import React from 'react'
import URLS from 'constant/URLS.js'

const ensureSession = (store, ensureLogout) => (nextState, replace, callback) => {
    const checkAuth = () => {
        const { session } = store.getState()
        if (!ensureLogout && !session.user) replace(URLS.session.login)
        else if (ensureLogout && session.user) replace(URLS.home)
        callback()
    }
    checkAuth()
}

export default (defaultStoreState) => {
    const store = initStore(defaultStoreState)
    const routes = (
        <Provider store={ store }>
            <Router history={ browserHistory }>
                <Route component={ App }>
                    <Route path={ URLS.session.login } component={ Anonymous } onEnter={ ensureSession(store, true) }>
                        <Route path={ URLS.session.resetPassword } component={ ResetPassword } />
                        <Route path={ URLS.session.setPassword } component={ SetPassword } /> 
                        <Route path={ URLS.session.newPassword } component={ NewPassword } /> 
                        <IndexRoute component={ Login } />
                    </Route>
                    <Route path={ URLS.home } component={ Logged } onEnter={ ensureSession(store) }>
                        <Route path={ URLS.client.index } component={ Clients }>
                            <Route path={ URLS.client.show } component={ Client } />
                        </Route>
                        <Route path={ URLS.users.index } component={ Users }>
                            <Route path={ URLS.users.show } component={ User } />
                        </Route>
                        <Route path={ URLS.hives.index } component={ Hives }/>
                        <IndexRoute component={ Home } />
                    </Route>
                </Route>
            </Router>
        </Provider>
    )
    return routes
}


// WEBPACK FOOTER //
// ./src/common/routes.jsx